import { LOADING, RESET_LOADING } from '../constants/ActionTypes';

const loading = (state = 0, action) => {
  switch (action.type) {
    case LOADING:
      if (action.isLoading) {
        return state + 1;
      } else {
        return state - 1;
      }
    case RESET_LOADING:
      return 0;
    default:
      return state;
  }
}

export default loading;



// WEBPACK FOOTER //
// ./src/reducers/loading.js